//Page Components
import Home from '../pages/HomePage/HomePage';
import Prayer from '../pages/PrayerPage/PrayerPage';
import MyPrayers from '../pages/MyPrayersPage/MyPrayersPage';
import PrayerUpdate from '../pages/PrayerUpdatePage/PrayerUpdatePage';
import FellowshipPage from '../pages/FellowshipPage/FellowshipPage';
import PrayerSessionSettingsPage from '../pages/PrayerSessionSettingsPage/PrayerSessionSettingsPage'
import PrayNow from '../pages/PrayNowPage/PrayNowPage';

import { ReactComponent as PrayerIcon } from '../assets/images/prayerLogo.svg';
import { bookSharp, swapVertical, chatbubblesSharp, listCircle, calendar, list, downloadOutline, informationCircleOutline} from 'ionicons/icons';
import IUser from '../interfaces/IUser';
import IRouteInfo from '../interfaces/IRouteInfo';
import RouteCategories from '../data/RouteCategories';
import { AllUserRoles } from '../data/UserRoles';
import { CreateRoutes } from '../services/RoutingHelperService';
import ReadingScheduler from '../pages/ReadingSchedulerPage/ReadingSchedulerPage';
import BibleStudyBrowser from '../pages/BibleStudyBrowser/BibleStudyBrowser';
import FellowshipCommentsPage from '../pages/FellowshipCommentsPage/FellowshipCommentsPage';
import FellowshipCreatePostPage from '../pages/FellowshipCreatePostPage/FellowshipCreatePostPage';
import InstallAppInstructionsPage from '../pages/InstallAppInstructionsPage/InstallAppInstructionsPage';
import BibleReadingPage from '../pages/BibleReadingPage/BibleReadingPage';
import AppInfoPage from '../pages/AppInfoPage/AppInfoPage';
import BibleTranslationNoticePage from '../pages/BibleTranslationNoticePage/BibleTranslationNoticePage';
import BiblePlanManagerPage from '../pages/BiblePlanManagerPage/BiblePlanManagerPage';
import FellowshipEditPostPage from '../pages/FellowshipEditPostPage/FellowshipEditPostPage';
import BiblePlanSelectorPage from '../pages/BiblePlanSelectorPage/BiblePlanSelectorPage';
import BibleNavigatorPage from '../pages/BibleNavigatorPage/BibleNavigatorPage';

export enum AppRouteKeys {
    Home,
    Bible,
    BibleTranslationNotice,
    BiblePlanManager,
    Prayer,
    PrayNow,
    MyPrayers,
    PrayerUpdate,
    PrayerSessionSettings,
    Fellowship,
    FellowshipCreatePost,
    FellowshipEditPost,
    FellowshipComments,
    ReadingScheduler,
    BibleStudyBrowser,
    InstallAppInstructions,
    AppInformation,
    BiblePlanSelector,
    BibleNavigator,
}

export const AppRouteInfo: {[key in AppRouteKeys]: IRouteInfo} = {
        [AppRouteKeys.Home]: 
        {
            title: 'Bible Study Together',
            path: '/home', 
            component: Home,
            themeColorName: 'medium',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.Bible]: 
        {
            title: 'Bible Study',
            path: '/bible/:planCode?/:session?/:version?', 
            rootPath: '/bible',
            component: BibleReadingPage,
            icon: bookSharp,
            themeColorName: 'primary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.BibleTranslationNotice]: 
        {
            title: 'Translations',
            path: '/translations', 
            component: BibleTranslationNoticePage,
            icon: bookSharp,
            themeColorName: 'primary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.BiblePlanManager]: 
        {
            title: 'Plan Manager',
            path: '/plans', 
            component: BiblePlanManagerPage,
            icon: bookSharp,
            themeColorName: 'primary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.BiblePlanSelector]: 
        {
            title: 'Pick a Plan',
            path: '/plan-selector/:groupId?',
            rootPath: '/plan-selector',
            component: BiblePlanSelectorPage,
            icon: bookSharp,
            themeColorName: 'primary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.Prayer]: 
        {
            title: 'Prayer',
            path: '/prayer', 
            component: Prayer,
            icon: swapVertical,
            SvgIcon: PrayerIcon,
            themeColorName: 'secondary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.PrayNow]: 
        {
            title: 'Pray Now',
            path: '/pray-now', 
            component: PrayNow,
            icon: swapVertical,
            SvgIcon: PrayerIcon,
            themeColorName: 'secondary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: false, // NOTE: must be manually Instantiated in App.tsx
        },
        [AppRouteKeys.MyPrayers]: 
        {
            title: 'My Prayers',
            path: '/my-prayers', 
            component: MyPrayers,
            icon: listCircle,
            themeColorName: 'secondary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.PrayerUpdate]:
        {
            title: 'Prayer',
            path: '/prayer-edit/:id',
            component: PrayerUpdate,
            icon: swapVertical,
            SvgIcon: PrayerIcon,
            themeColorName: 'secondary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.PrayerSessionSettings]:
        {
            title: 'Settings',
            path: '/prayer-session-settings',
            component: PrayerSessionSettingsPage,
            icon: swapVertical,
            SvgIcon: PrayerIcon,
            themeColorName: 'secondary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.Fellowship]:
        {
            title: 'Fellowship',
            path: '/fellowship',
            component: FellowshipPage,
            icon: chatbubblesSharp,
            themeColorName: 'tertiary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.FellowshipComments]:
        {
            title: 'Fellowship',
            path: '/fellowship-comments/:navigation/:postId',
            component: FellowshipCommentsPage,
            icon: chatbubblesSharp,
            themeColorName: 'tertiary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.FellowshipCreatePost]:
        {
            title: 'Fellowship',
            path: '/fellowship-create-post/:postType?/:shareIdentifier?',
            component: FellowshipCreatePostPage,
            icon: chatbubblesSharp,
            themeColorName: 'tertiary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.FellowshipEditPost]:
        {
            title: 'Edit Post',
            path: '/fellowship-edit-post/:postId',
            component: FellowshipEditPostPage,
            icon: chatbubblesSharp,
            themeColorName: 'tertiary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.ReadingScheduler]:
        {
            title: 'Setup Plan',
            path: '/setup-reading-schedule/:planCode?/:recordId?/:groupId?',
            rootPath: '/setup-reading-schedule',
            component: ReadingScheduler,
            icon: calendar,
            themeColorName: 'primary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.BibleStudyBrowser]:
        {
            title: 'Browse Days',
            path: '/bible-study-browser',
            component: BibleStudyBrowser,
            icon: list,
            themeColorName: 'primary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.BibleNavigator]:
        {
            title: 'Bible Navigator',
            path: '/bible-navigator/:lastSessionId?',
            rootPath: '/bible-navigator',
            component: BibleNavigatorPage,
            icon: list,
            themeColorName: 'primary',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.InstallAppInstructions]:
        {
            title: 'Install App',
            path: '/install-app-instructions',
            component: InstallAppInstructionsPage,
            icon: downloadOutline,
            themeColorName: 'medium',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
        [AppRouteKeys.AppInformation]:
        {
            title: 'App Info',
            path: '/app-information',
            component: AppInfoPage,
            icon: informationCircleOutline,
            themeColorName: 'medium',
            category: RouteCategories.everyone,
            roles: AllUserRoles,
            autoInstantiate: true,
        },
    }

//This can be used for looping through the Routes
export const AppRouteInfoArray = Array.from(Object.values(AppRouteInfo));

export const AppRoutes = (loggedIn:boolean, currentUser:IUser | undefined) => CreateRoutes(AppRouteInfoArray, 'AppRoutes', loggedIn, currentUser);

export default AppRoutes;